import Cookies from "js-cookie";
import jwt from "jsonwebtoken";
import api from "./api";
import ApiV2 from "./apiV2";

export default class IdentityService {
  static COGNITO_ID_TOKEN = "cognito_id_token";
  static COGNITO_ACCESS_TOKEN = "cognito_access_token";
  static COGNITO_REFRESH_TOKEN = "cognito_refresh_token";

  static COOKIE_NAMES = [
    IdentityService.COGNITO_ID_TOKEN,
    IdentityService.COGNITO_ACCESS_TOKEN,
    IdentityService.COGNITO_REFRESH_TOKEN
  ];

  static POOLDATA = this.getCognitoInstance(); 

  static async authenticate(email = "", password = "") {
    const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
    const username = email;
    const authenticationData = {
      Username: username,
      Password: password
    };
    const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
      authenticationData
    );

    const userPool = new AmazonCognitoIdentity.CognitoUserPool(this.POOLDATA);
    const userData = {
      Username: username,
      Pool: userPool
    };
    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    const authPromise = new Promise(function(resolve, reject) {
        cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: resolve,
        onFailure: reject
      });
    });

    try {
      const { idToken, accessToken, refreshToken } = await authPromise;
      Cookies.set(this.COGNITO_ID_TOKEN, idToken.getJwtToken());
      Cookies.set(this.COGNITO_ACCESS_TOKEN, accessToken.getJwtToken());
      Cookies.set(this.COGNITO_REFRESH_TOKEN, refreshToken.token);
    } catch (e) {
        throw e;
    }
  }


  /**
   * This uses the refreshToken to retrieve a new session
   * @param {email} email Users email you want to refresh tokens for.
   * @returns {void}
   */
  static async refreshSession(email = ""){
    const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
    const refreshtoken = Cookies.get("cognito_refresh_token");

    var CognitoRefreshToken = require('amazon-cognito-identity-js').CognitoRefreshToken;

    var token = new CognitoRefreshToken({ RefreshToken: refreshtoken })
    
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(this.POOLDATA);
    const userData = {
      Username: email,
      Pool: userPool
    };

    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

    // WARNING
    // TODO: find a way to wait for cognitoUser.refreshSession() to finish before grabbing cookies instead of timeout.
    // explanation: cognitoUser.refreshSession is asynchronous but does not return a promise so we can't use an await on it.
    // added a timeout because we needed a way to make sure refreshSession() finishes before executing the next lines of code.
    // consequences: 
    // - it's not guarenteed that the 1 second timeout will be enough time for refreshSession() to complete
    // - timeout more than 1 second will impact user experience.
    var timer = null;
    await new Promise(r => {
      timer = setTimeout(r, 1000); // timeout for 1 second
      cognitoUser.refreshSession(token, (err, session) => {
        if (err){
          throw err;
        }
        else{
          Cookies.set(this.COGNITO_ID_TOKEN, session.getIdToken().getJwtToken());
          Cookies.set(this.COGNITO_ACCESS_TOKEN, session.getAccessToken().getJwtToken());
        }
      });
    });
  }

  static async register(email, password, firstName,lastName,isPublic,DOB) {
    const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(this.POOLDATA);

    var attributeList = [];

    var dataEmail = {
      Name: "email",
      Value: email
    };

    var dataFirstName = {
      Name: "custom:firstName",
      Value: firstName.toLowerCase()
    };

    var dataLastName = {
      Name: "custom:lastName",
      Value: lastName.toLowerCase()
    };

    var dataIsPublic = {
      Name: "custom:isPublic",
      Value: isPublic.toString()
    };

    var dataDOB = {
      Name: "custom:DOB",
      Value: DOB
    };

    var attributeEmail = new AmazonCognitoIdentity.CognitoUserAttribute(
      dataEmail
    );
    var attributeFirstName = new AmazonCognitoIdentity.CognitoUserAttribute(
      dataFirstName
    );
    var attributeLastName = new AmazonCognitoIdentity.CognitoUserAttribute(
      dataLastName
    );
    var attributeIsPublic = new AmazonCognitoIdentity.CognitoUserAttribute(
      dataIsPublic
    );
    var attributeDOB = new AmazonCognitoIdentity.CognitoUserAttribute(
      dataDOB
    );

    attributeList.push(attributeEmail, attributeFirstName, attributeLastName, attributeIsPublic, attributeDOB);

    const username = email;
    const registerPromise = new Promise(function(resolve, reject) {
      userPool.signUp(username, password, attributeList, null, function(
        err,
        result
      ) {
        if (err) {
          reject(err);
        }

        //add user that was just created to the users table
        if( result !== null ){
          const response = ApiV2.addUser(
            result.userSub,
            email,
            firstName.toLowerCase(),
            lastName.toLowerCase(),
            isPublic,
            DOB
          );
        }
        resolve(result);
      });
    });
    return registerPromise;
  }

  static async isLoggedIn(){

    var idToken;
    try{
      idToken = await ApiV2.getIdToken();
    } catch(e){
      console.log(e)
      return false;
    }
    const currTime = Date.now().valueOf();              // grab the current time
    const expTime = jwt.decode(idToken).exp * 1000; // grab the access tokens expiration time and convert it into JS DateTime

    if (currTime <= expTime){
      return true; 
    } else {
      return false
    }
  }

  static logout() {
    this.COOKIE_NAMES.forEach(cookieName => {
      Cookies.remove(cookieName);
    });
  }

  static getCognitoInstance() {
    const currentUrl = window.location.href;
    const cognitoInstances = JSON.parse(process.env.REACT_APP_COGNITO_POOLS);
    console.log("COGNITO POOLS", cognitoInstances)
    if (currentUrl.includes("localhost")) {
      return cognitoInstances["dev"];
    } else if (currentUrl.includes("prod.")) {
      return cognitoInstances["dev"];
    } else if (currentUrl.includes("prodeu.")) {
      return cognitoInstances["dev"];
    } else if (currentUrl.includes("hostingbucket")) {
      return cognitoInstances["dev"];
    } else {
      return cognitoInstances["dev"];
    }
  }

}
